import { MainMenuProps } from "./components/MainMenuContent/types";
import { SidebarProvider } from "../../routes/SidebarProvider";
import { MainMenuContent } from "./components/MainMenuContent";

export function MainMenu({ pages }: MainMenuProps) {
    return (
        <SidebarProvider>
            <MainMenuContent pages={pages} />
        </SidebarProvider>
    );
}